/**
 * خدمة SignalR للاتصال بـ TripChatHub (متابعة الرحلة والموقع المباشر).
 * الاستخدام: this.$tripHub.start() ثم joinTripGroup(tripCode) واستقبال ReceiveLocation.
 *
 * إذا ظهر "Server timeout elapsed without receiving a message":
 * - تأكد أن الواجهة الأمامية والـ API على نفس النطاق أو أن الـ proxy يوجّه /tripChatHub إلى السيرفر.
 * - خلف reverse proxy (IIS/nginx): فعّل WebSocket وزد مهلة الـ timeout.
 */
import * as signalR from '@microsoft/signalr';

const HUB_URL = (typeof process !== 'undefined' && process.env && process.env.VUE_APP_HUB_URL) || '/tripChatHub';

let connection = null;

export default {
  isConnected() {
    return connection && connection.state === signalR.HubConnectionState.Connected;
  },

  async start() {
    if (this.isConnected()) return;
    if (connection && connection.state === signalR.HubConnectionState.Connecting) return;

    if (connection) {
      try {
        await connection.stop();
      } catch (_) { /* ignore */ }
    }

    connection = new signalR.HubConnectionBuilder()
      .withUrl(HUB_URL, { withCredentials: true })
      .withAutomaticReconnect()
      .withServerTimeout(60000)
      .withKeepAliveInterval(15000)
      .build();

    try {
      await connection.start();
      return true;
    } catch (err) {
      console.error('TripChatHub connection error:', err);
      return false;
    }
  },

  async stop() {
    if (!connection) return;
    try {
      await connection.stop();
    } catch (_) { /* ignore */ }
    connection = null;
  },

  async joinTripGroup(tripIdOrCode) {
    if (!this.isConnected() || !tripIdOrCode) return false;
    try {
      await connection.invoke('JoinTripGroup', String(tripIdOrCode));
      return true;
    } catch (err) {
      console.error('JoinTripGroup error:', err);
      return false;
    }
  },

  async leaveTripGroup(tripIdOrCode) {
    if (!this.isConnected() || !tripIdOrCode) return false;
    try {
      await connection.invoke('LeaveTripGroup', String(tripIdOrCode));
      return true;
    } catch (err) {
      console.error('LeaveTripGroup error:', err);
      return false;
    }
  },

  /**
   * الاستماع لحدث الموقع المباشر من السائق.
   * @param {function} callback - يُستدعى بـ (data) حيث data = { lat, lng, heading }
   */
  onReceiveLocation(callback) {
    if (!connection) return;
    connection.off('ReceiveLocation');
    connection.on('ReceiveLocation', callback);
  },

  offReceiveLocation() {
    if (connection) connection.off('ReceiveLocation');
  },

  /**
   * إرسال الموقع من الفرونت (للتطبيق الذي يمثل السائق مثلاً).
   * @param {string} tripCode - كود الرحلة
   * @param {number} lat - خط العرض
   * @param {number} lng - خط الطول
   * @param {number} [heading=0] - اتجاه السيارة (0-360)
   */
  async sendLocation(tripCode, lat, lng, heading = 0) {
    if (!this.isConnected() || !tripCode) return false;
    try {
      await connection.invoke('SendLocation', tripCode, lat, lng, heading);
      return true;
    } catch (err) {
      console.error('SendLocation error:', err);
      return false;
    }
  }
};
